var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoardItemHidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 332,
    height: 332,
    viewBox: "0 0 332 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.026,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#f7cb6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#fba800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e67300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.026,
    x2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.026,
    x2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Path_5",
    x: 81.208,
    y: 41.66,
    width: 169.812,
    height: 230.14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-812 -1931)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 332,
    height: 332,
    rx: 24,
    transform: "translate(812 1931)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 306,
    height: 306,
    rx: 24,
    transform: "translate(825 1944)",
    opacity: 0.823,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 290,
    height: 290,
    rx: 24,
    transform: "translate(833 1952)",
    opacity: 0.345,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 812, 1931)",
    filter: "url(#Path_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    "data-name": "Path 5",
    d: "M-.46-53.82q-9.66,0-13.685-2.645a10.36,10.36,0,0,1-4.83-6.785,44.486,44.486,0,0,1-.805-8.51v-1.61q0-7.36,2.415-11.73a20.426,20.426,0,0,1,6.21-7.015,39.75,39.75,0,0,1,8.165-4.37q4.37-1.725,8.165-3.45a18.807,18.807,0,0,0,6.21-4.37A10.34,10.34,0,0,0,13.8-111.55q0-6.67-3.68-9.66T-1.84-124.2a18.289,18.289,0,0,0-6.21.92,10.312,10.312,0,0,0-3.795,2.185A10.243,10.243,0,0,0-13.8-118.45a39.5,39.5,0,0,1-5.175,10.81,11.352,11.352,0,0,1-7.245,4.715q-4.37.8-11.73-1.955-7.82-3.22-11.385-6.21a10.2,10.2,0,0,1-3.91-7.13q-.345-4.14,1.725-10.81.23-.69,1.725-4.255a55.821,55.821,0,0,1,4.715-8.51,46.665,46.665,0,0,1,8.855-9.775,47.46,47.46,0,0,1,14.03-8.05q8.4-3.22,20.355-3.22a54.667,54.667,0,0,1,27.255,6.785,51.766,51.766,0,0,1,19.09,18.17A47.9,47.9,0,0,1,51.52-112.24,44.872,44.872,0,0,1,48.3-94.415,38.946,38.946,0,0,1,40.25-82.11a45.013,45.013,0,0,1-9.775,7.59,49.041,49.041,0,0,1-8.51,3.91,23.752,23.752,0,0,1-4.255,1.15l1.61-2.76v2.3a32.588,32.588,0,0,1-.92,7.7,9.543,9.543,0,0,1-5.06,6.1Q9.2-53.82-.46-53.82ZM-1.15,2.3q-13.34,0-17.6-5.06T-23-20.01a56.465,56.465,0,0,1,.92-10.12,13.041,13.041,0,0,1,5.52-8.4q4.6-3.335,15.64-3.335,13.57,0,17.825,5.06T21.16-19.55a56.465,56.465,0,0,1-.92,10.12,12.931,12.931,0,0,1-5.635,8.4Q9.89,2.3-1.15,2.3Z",
    transform: "translate(167 237)",
    fill: "#ae3e25",
    stroke: "#f8c066",
    strokeLinecap: "round",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-.46-53.82q-9.66,0-13.685-2.645a10.36,10.36,0,0,1-4.83-6.785,44.486,44.486,0,0,1-.805-8.51v-1.61q0-7.36,2.415-11.73a20.426,20.426,0,0,1,6.21-7.015,39.75,39.75,0,0,1,8.165-4.37q4.37-1.725,8.165-3.45a18.807,18.807,0,0,0,6.21-4.37A10.34,10.34,0,0,0,13.8-111.55q0-6.67-3.68-9.66T-1.84-124.2a18.289,18.289,0,0,0-6.21.92,10.312,10.312,0,0,0-3.795,2.185A10.243,10.243,0,0,0-13.8-118.45a39.5,39.5,0,0,1-5.175,10.81,11.352,11.352,0,0,1-7.245,4.715q-4.37.8-11.73-1.955-7.82-3.22-11.385-6.21a10.2,10.2,0,0,1-3.91-7.13q-.345-4.14,1.725-10.81.23-.69,1.725-4.255a55.821,55.821,0,0,1,4.715-8.51,46.665,46.665,0,0,1,8.855-9.775,47.46,47.46,0,0,1,14.03-8.05q8.4-3.22,20.355-3.22a54.667,54.667,0,0,1,27.255,6.785,51.766,51.766,0,0,1,19.09,18.17A47.9,47.9,0,0,1,51.52-112.24,44.872,44.872,0,0,1,48.3-94.415,38.946,38.946,0,0,1,40.25-82.11a45.013,45.013,0,0,1-9.775,7.59,49.041,49.041,0,0,1-8.51,3.91,23.752,23.752,0,0,1-4.255,1.15l1.61-2.76v2.3a32.588,32.588,0,0,1-.92,7.7,9.543,9.543,0,0,1-5.06,6.1Q9.2-53.82-.46-53.82ZM-1.15,2.3q-13.34,0-17.6-5.06T-23-20.01a56.465,56.465,0,0,1,.92-10.12,13.041,13.041,0,0,1,5.52-8.4q4.6-3.335,15.64-3.335,13.57,0,17.825,5.06T21.16-19.55a56.465,56.465,0,0,1-.92,10.12,12.931,12.931,0,0,1-5.635,8.4Q9.89,2.3-1.15,2.3Z",
    transform: "translate(979 2168)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardItemHidden);
export default __webpack_public_path__ + "static/media/board_item_hidden.75153a50dfb2560debf08c6ed42df16d.svg";
export { ForwardRef as ReactComponent };